import { Input, InputProps } from './Input';
import { FieldErrors, FieldValues, Path, RegisterOptions, UseFormRegister } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { get } from 'lodash';

export type FormInputProps<TFormValues extends FieldValues> = {
    showLabel?: boolean;
    name: Path<TFormValues>;
    rules?: RegisterOptions<TFormValues>;
    register?: UseFormRegister<TFormValues>;
    errors?: FieldErrors<TFormValues>;
    classNameInput?: string;
    classNameLabel?: string;
    isRequired?: boolean;
} & Omit<InputProps, 'name'>;

export const FormInput = <TFormValues extends FieldValues>({
    className = '',
    classNameInput = '',
    classNameLabel = '',
    name,
    register,
    rules,
    errors,
    showLabel,
    isRequired,
    ...props
}: FormInputProps<TFormValues>): JSX.Element => {
    const errorMessages = get(errors, name);
    const hasError = !!errorMessages;

    return (
        <div className={`w-full ${className}`} aria-live="polite">
            <Input
                showLabel={showLabel}
                name={name}
                {...props}
                {...(register && register(name, rules))}
                error={hasError}
                aria-invalid={hasError}
                className={classNameInput}
                classNameLabel={classNameLabel}
                isRequired={isRequired}
            />
            {hasError && (
                <ErrorMessage
                    errors={errors}
                    name={name as any}
                    render={({ message }) => (
                        <p className="mt-1 text-bsmall block text-[#BA1A1A]">
                            {message}
                        </p>
                    )}
                />
            )}
        </div>
    );
};